// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UTCFW","card":"styles_card__30BnN","col":"styles_col__Clz+R","row":"styles_row__YS+eY"};